(function() {
  'use strict';
  
  angular
    .module('app.myPolls')
    .controller('UpcomingController', UpcomingController);
      
  UpcomingController.$inject = [
    '$log', 
    '$scope',
    '$state',
    '$mdToast',
    '$window',
    'localStorageService',
    'metrics',
    'shell',
    'myPollsService'
  ];
    
  function UpcomingController(
    $log,
    $scope, 
    $state,
    $mdToast,
    $window,
    localStorageService,
    metrics,
    shell,
    myPollsService
    ) {
    
    $log = $log.getInstance('UpcomingController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.filteredGroups = null;
    vm.groups = null;
    vm.fluxBannerHidden = true;
    vm.hideFluxBanner = hideFluxBanner;
    vm.markGroupAsDone = markGroupAsDone;
    vm.goToFlux = goToFlux;
    vm.viewResult = viewResult;
    
    activate();
    
    function activate() {
      shell.setTitle('Upcoming Polls');
      shell.setSearch(_searchCallback);
      myPollsService.getCollections().then(function(collections) {
        vm.groups = _upcomingGroups(collections);
        _searchCallback();
      });
      vm.fluxBannerHidden = localStorageService.get('mars.fluxBannerHidden');
    }
    
    
    function markGroupAsDone(index) {
      var group = vm.groups.splice(index, 1);
      var undoUpcoming = null;

      if (group.length === 0)
        return;
      
      group = group[0];
      undoUpcoming = group.upcoming;
      group.upcoming = null;
      myPollsService.updateGroup(group, 'upcoming')
        .then(function() { metrics.log('unpin'); });
      
      $mdToast.show($mdToast.simple()
        .textContent('Unpinned from Upcoming Polls')
        .action('UNDO')
        .highlightAction(true)
        .position('bottom right')
      ).then(function(response) {
        if ( response === 'ok' ) {
          group.upcoming = undoUpcoming;
          vm.groups.splice(index, 0, group);
          myPollsService.updateGroup(group, 'upcoming')
            .then(function() { metrics.log('unpin undo'); });
        }
      });
    }
    
    function viewResult(poll) {
      $log.debug('viewResult: ', poll._id);
      var resultCallback = function(result) {
        $state.go('result', { resultId: result._id, mode: 'live' });
      };
      return myPollsService.getLastResult(poll)
        .then(resultCallback)
        .catch(function(err) {
          if (err.code && err.code === 404)
            return myPollsService.createResult(poll).then(resultCallback);
        });
    }
    
    
    function _searchCallback(phrase) {
      vm.filteredGroups = myPollsService.searchGroups(vm.groups, phrase);
    }
    
    function _upcomingGroups(collections) {
      var now = new Date();
      var groups = _.pluck(collections, 'groups');
      return _.filter(
        _.flatten(_.zip.apply(null, groups)), function(group) {
          return _.has(group, 'upcoming') 
            && angular.isDate(group.upcoming) 
            && !angular.isDate(group.deleted);
        });
    }

    function goToFlux() {
      metrics.log('transition to flux');
      $window.open(
        'https://flux.qa/info/sign-up',
        '_blank',
        'toolbar=yes, location=yes, status=yes, menubar=yes, scrollbars=yes'
      );
    }

    function hideFluxBanner() {
      metrics.log('flux ignore');
      vm.fluxBannerHidden = true;
      localStorageService.set('mars.fluxBannerHidden', new Date());
    }
    
  }
  
})();